import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationLargestArmyView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLargestArmyView'
import {GameColor} from '../../../../shared/scripts/GameColor'
import {UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'

export class UIMGamePlayerInformationLargestArmyView extends UIGamePlayerInformationLargestArmyView {
    protected createMyLargestArmyView() {
        // design: https://www.figma.com/file/KjHdwcS3tBLtE3DXFKyJQK/Mobile-Game-Master-File?type=design&node-id=20-43286&t=6rTCnRdO8FTGiJup-0
        this.createLargestArmyView()
    }

    protected createOpponentLargestArmyView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        this.createLargestArmyView()
    }

    private createLargestArmyView() {
        const container = this.playerInformation.getContainerForAdditionalPlayerInformation(UIPlayerAdditionalInformationLayer.Layer0)
        const w = container.width
        const h = container.height

        const iconX = w * 0.1
        const iconY = h * 0.5
        const iconW = h * 0.4
        const iconH = iconW

        const countX = iconX + iconW * 0.5
        const countY = iconY * 1
        const countH = iconH
        const countW = countH * 2

        const iconPadding = 0
        const fontSize = iconH * 0.9

        this.largestArmyView = new ItemCountView(iconX, iconY, iconW, iconH, container, this.largestArmyTexture,
            countX, countY, countW, countH, iconPadding,
            fontSize, GameColor.getColor(GameColor.Color.White))
        this.largestArmyView.count.changeStyle({
            fontSize: fontSize,
        })
    }
}
